import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Form } from 'foundations-components/transitional/components/Form';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';

// @ts-expect-error untyped module
import { useHideDialog } from '../../../dialog/ducks';
// @ts-expect-error untyped module
import ActionSubmitButton from '../../shared/ActionSubmitButton';
// @ts-expect-error untyped module
import { ACTION_STATUSES } from '../../shared/actionStatuses';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AddSectionHeaderToDashboardDialog = ({
  onSave,
  actionStatus = ACTION_STATUSES.NOT_STARTED,
  prevSectionHeading = '',
  prevSectionDescription = ''
}) => {
  const hideDialog = useHideDialog();
  const [sectionHeading, setSectionHeading] = useState(prevSectionHeading);
  const [sectionDescription, setSectionDecription] = useState(prevSectionDescription);
  const handleCloseDialog = () => hideDialog();
  const handleSectionHeadingChange = ({
    target: {
      value: newSectionHeading
    }
  }) => {
    setSectionHeading(newSectionHeading);
  };
  const handleSectionDescriptionChange = ({
    target: {
      value: newSectionDescription
    }
  }) => {
    setSectionDecription(newSectionDescription);
  };
  const isSaveDisabled = !sectionHeading;
  const isEditingExistingSectionHeader = !!prevSectionHeading;
  return /*#__PURE__*/_jsxs(Modal, {
    width: 800,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: handleCloseDialog
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: isEditingExistingSectionHeader ? 'reporting-action-components.actions.addSectionHeader.dialog.title.edit' : 'reporting-action-components.actions.addSectionHeader.dialog.title.new'
        })
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsxs(Form, {
        children: [/*#__PURE__*/_jsx(FormControl, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reporting-action-components.actions.addSectionHeader.dialog.sectionHeadingField"
          }),
          required: true,
          children: /*#__PURE__*/_jsx(TextInput, {
            value: sectionHeading,
            onChange: handleSectionHeadingChange
          })
        }), /*#__PURE__*/_jsx(FormControl, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reporting-action-components.actions.addSectionHeader.dialog.sectionDescriptionField"
          }),
          children: /*#__PURE__*/_jsx(TextArea, {
            value: sectionDescription,
            onChange: handleSectionDescriptionChange
          })
        })]
      })
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Tooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.addSectionHeader.dialog.save.disabledTooltip"
        }),
        disabled: !isSaveDisabled,
        children: /*#__PURE__*/_jsx(ActionSubmitButton, {
          use: "primary",
          actionStatus: actionStatus,
          onClick: () => onSave({
            sectionHeading,
            sectionDescription
          }),
          disabled: isSaveDisabled,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reporting-action-components.actions.addSectionHeader.dialog.save.button"
          })
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "secondary",
        onClick: handleCloseDialog,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.addSectionHeader.dialog.cancelButton"
        })
      })]
    })]
  });
};
export default AddSectionHeaderToDashboardDialog;